import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import TablaDetalleVer from './DetalleOrdenServicioVer';

import {
    AsyncSelectField,
    renderField,
    renderDayPickerB,
    SelectField
} from "../../Utils/renderField/renderField";

function DetalleOrdenServicioForm(props) {
    const {
        periodoD,
        modulo,
        listarClientes,
        titulo,
        crear,
        editar,
        bloqueo,
        registroOrden,
        modificarOrden,
        detalleOrd,
        lectura
    } = props;

    let autoFocus = true;
    const estilo = {
        overflow: "auto",
        height: "500px",

    };
     
    const tipo = [
        {
            value: 'LOC',
            label: 'LOCAL'
        },
        {
            value: 'EXP',
            label: 'EXTERIOR'
        },
    ];
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <NavbarModulo
                periodoD={periodoD}
                modulo={modulo}
                titulo={titulo}
            />
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='row mb-2'>
                            <div className='col-2'>
                                <Field
                                    autoFocus={autoFocus}
                                    disabled={bloqueo}
                                    name="fecha"
                                    component={renderDayPickerB}
                                    msj="Fecha inicio proyecto"
                                />
                            </div>
                            <div className='col-2'>
                                <Field
                                    disabled={bloqueo}
                                    name="fecha_estimada_cierre"
                                    component={renderDayPickerB}
                                    msj="Fecha estimada"
                                />
                            </div>
                            <div className='col-8'>
                                <Field
                                    name="nombre_proyecto"
                                    placeholder="Nombre proyecto"
                                    className="form-control"
                                    component={renderField}
                                    disabled={bloqueo}
                                    msj="Nombre proyecto"
                                />
                            </div>
                        </div>
                        {crear === true &&
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <Field
                                        name="cliente"
                                        placeholder="Cliente..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarClientes}
                                        msj="Cliente"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === true &&
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <Field
                                        name="clienteN"
                                        placeholder="Cliente"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Cliente"
                                    />
                                </div>
                                <div className='col-12'>
                                    <Field
                                        name="cliente_proyecto"
                                        placeholder="Cliente..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarClientes}
                                        msj="Cliente"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-2'>
                                    <Field
                                        name="serie"
                                        placeholder="Serie"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Serie"
                                    />
                                </div>
                                <div className='col-2'>
                                    <Field
                                        name="numero"
                                        placeholder="Numero"
                                        className="form-control"
                                        component={renderField}
                                        disabled={true}
                                        msj="Numero"
                                    />
                                </div>
                            </div>
                        }
                        {crear === false && editar === false &&
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <Field
                                        name="clienteN"
                                        placeholder="Cliente"
                                        className="form-control"
                                        component={renderField}
                                        disabled={bloqueo}
                                        msj="Cliente"
                                    />
                                </div>
                            </div>
                        }
                        <div className='row mb-2'>
                            <div className='col-10'>
                                <Field
                                    name="observaciones"
                                    placeholder="Observaciones"
                                    component={renderField}
                                    className="form-control"
                                    disabled={bloqueo}
                                    msj="Observaciones"
                                />
                            </div>
                            <div className='col-2'>
                                <div className="form-floating">
                                    <Field
                                        name="tipo"
                                        options={tipo}
                                        dato={crear === true ? 0 : lectura}
                                        component={SelectField}
                                        className="form-select"
                                        disabled={bloqueo}
                                        msj="Tipo"
                                    />
                                </div>
                            </div>
                        </div>
                        {crear === false && editar === false &&
                            <div>
                                <h5 className="p-2 bg-secondary title mt-1">Detalle de productos y gastos</h5>
                                <div style={estilo}>
                                    
                                    <TablaDetalleVer
                                        detalle={detalleOrd}
                                    />
                                </div>
                            </div>
                        }
                        <br />
                        <div className='d-flex flex-row mt-3'>
                            {crear === true && editar === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => registroOrden(periodoD)}
                                >
                                    Guardar
                                </button>
                            }
                            {editar === true && crear === false &&
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={() => modificarOrden(periodoD)}
                                >
                                    Modificar
                                </button>
                            }
                            <a
                                href={`/#/gestion_proyecto/${id_emp[5]}/proyecto/${id_emp[7]}`}
                                className='btn btn-secondary mb-3'
                            >
                                Regresar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

DetalleOrdenServicioForm.propTypes = {
    crear: PropTypes.bool,
};

export default reduxForm({
    form: 'FormOrdenServicioINV',
})(DetalleOrdenServicioForm);

